import { APIClientBase } from './api-client-base'
import { ClosurePeriodSettingsGetRequest, ClosurePeriodSettingsGetResponse } from '@/dtos/closure-period-settings/get'
import { ClosurePeriodSettingDeleteRequest } from '@/dtos/closure-period-settings/delete'
import { ClosurePeriodSettingPostRequest } from '@/dtos/closure-period-settings/post'
import { ClosurePeriodSettingPutRequest } from '@/dtos/closure-period-settings/put'

class ClosurePeriodSettingsClient extends APIClientBase {
  constructor() {
    super('/closure-period-settings')
  }

  // 休業期間設定一覧取得
  getClosurePeriodSettings(req: ClosurePeriodSettingsGetRequest) {
    return this.get('', req, ClosurePeriodSettingsGetResponse)
  }

  // 休業期間設定登録
  postClosurePeriodSetting(req: ClosurePeriodSettingPostRequest) {
    return this.post('', req)
  }

  // 休業期間設定削除
  deleteClosurePeriodSetting(req: ClosurePeriodSettingDeleteRequest): Promise<void> {
    return this.delete(`${req.closurePeriodSettingId}`)
  }

  // 休業期間設定更新
  putClosurePeriodSetting(req: ClosurePeriodSettingPutRequest) {
    const { closurePeriodSettingId, ...body } = req
    return this.put(`${closurePeriodSettingId}`, body, ClosurePeriodSettingPutRequest)
  }
}

export const closurePeriodSettingsClient = new ClosurePeriodSettingsClient()
